import { __read } from "tslib";
import React, { useState } from 'react';
import { TextTranslator } from './TextTranslator';
import { TranslatorBubble } from './TranslatorBubble';
import { getBoolVariation } from '../../lib/featbit';
import ReactDOM from 'react-dom';
import { Fetch } from '@ekuaibao/fetch';
import { getLanguageByLanguageCode } from '../utils';
var HyperTranslator = function (_a) {
    var translateConfig = _a.translateConfig, target = _a.target;
    var _b = __read(useState(false), 2), isClose = _b[0], setClose = _b[1];
    var onBubbleClose = function () {
        setClose(true);
    };
    if (isClose || !getBoolVariation('ao-20-hyper-translator') || window.localStorage.getItem(Fetch.ekbCorpId + "_enableHyperTranslate") === 'close')
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(TextTranslator, { translateConfig: translateConfig }),
        React.createElement(TranslatorBubble, { translateConfig: translateConfig, onBubbleClose: onBubbleClose, target: target })));
};
var languageMap = {
    cn: "chinese_simplified",
    "zh-CN": "chinese_simplified",
    en: "english",
    "en-US": "english",
    english: "english",
};
export function initTranslator(translateConfig, target) {
    console.log('initTranslator', target);
    translateConfig.translate.language.translateLocal = false;
    var language = getLanguageByLanguageCode(target);
    var languageCode = languageMap[language] || language;
    translateConfig.translate.language.setLocal(languageCode);
    if (['zh-CN', 'en-US'].includes(target)) {
        translateConfig.translate.language.setDefaultTo(languageCode);
    }
    else {
        translateConfig.translate.ignore.class.push('translate-ignore-class');
        translateConfig.setToLanguage(target);
    }
    translateConfig.initTranslate();
    var existingContainer = document.getElementById('hyber-translator-container');
    if (existingContainer) {
        return;
    }
    var container = document.createElement('div');
    container.id = 'hyber-translator-container';
    document.body.appendChild(container);
    ReactDOM.render(React.createElement(HyperTranslator, { translateConfig: translateConfig, target: target }), container);
}
